import { Button, Callout } from '@main/complykit';
import { Policy_Integration_Error_Statuses_Enum } from '@main/graphql/types.generated';
import { useTranslation } from 'react-i18next';

export type PolicyIntegrationRetryAlertProps = {
  status: Policy_Integration_Error_Statuses_Enum;
  isLoading?: boolean;
  isDisabled?: boolean;
  onRetry: () => void;
};

export const PolicyIntegrationRetryAlert = ({
  status,
  isLoading,
  isDisabled,
  onRetry,
}: PolicyIntegrationRetryAlertProps) => {
  const { t } = useTranslation('integrations');

  return (
    <Callout
      status="error"
      title={t('policyIntegrationRetryAlert.title')}
      action={
        <Button
          tone="critical"
          variant="outline"
          isPending={isLoading}
          isDisabled={isDisabled}
          onPress={onRetry}
        >
          {t('policyIntegrationRetryAlert.retry')}
        </Button>
      }
    >
      {t(`policyIntegrationErrorStatus.${status}`)}
    </Callout>
  );
};
